function updatePostRecord(post, postId, patch) {
  if (!post || String(post.id) !== String(postId)) return post;
  return { ...post, ...patch };
}

export function updatePostCaches(queryClient, postId, patch) {
  const cachedPosts = queryClient.getQueriesData({ queryKey: ["posts"] });
  cachedPosts.forEach(([queryKey, cached]) => {
    if (!cached) return cached;
    if (!["feed", "explore", "detail"].includes(queryKey[1])) return;

    if (Array.isArray(cached.pages)) {
      queryClient.setQueryData(queryKey, {
        ...cached,
        pages: cached.pages.map((page) =>
          page?.results
            ? {
                ...page,
                results: page.results.map((post) => updatePostRecord(post, postId, patch)),
              }
            : page,
        ),
      });
      return;
    }

    queryClient.setQueryData(queryKey, updatePostRecord(cached, postId, patch));
  });

  queryClient.setQueryData(["posts", "detail", String(postId)], (cached) =>
    updatePostRecord(cached, postId, patch),
  );
}

export function restorePostCaches(queryClient, snapshots) {
  snapshots.forEach(([queryKey, data]) => queryClient.setQueryData(queryKey, data));
}

export function invalidatePostQueries(queryClient, { includeDetail = false } = {}) {
  const scopes = includeDetail ? ["feed", "explore", "detail"] : ["feed", "explore"];
  return Promise.all(
    scopes.map((scope) =>
      queryClient.invalidateQueries({ queryKey: ["posts", scope] }),
    ),
  );
}
